import _extends from "@babel/runtime/helpers/extends";
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createUseStyles, Text, useTheme } from 'hoi-poi-ui';
import { getOverrides } from "../../utils/overrides";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'EmptyScreen');
const EmptyScreen = _ref => {
  let {
    className,
    buttons = [],
    title,
    description,
    illustration,
    iconType,
    overrides: overridesProp,
    onTracking,
    children
  } = _ref;
  const theme = useTheme();
  const override = getOverrides(overridesProp, EmptyScreen.overrides);
  const classes = useStyles();
  const rootClassNames = classnames(classes.root, className);
  const buttonList = buttons.map((button, index) => {
    if (!button) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.button,
      key: index
    }, button);
  });
  const renderImageFirst = useMemo(() => /*#__PURE__*/React.createElement("div", _extends({
    className: classes.emptyView
  }, override.emptyView), illustration && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.illustration
  }, override.illustration), illustration), /*#__PURE__*/React.createElement(Text, _extends({
    type: "subtitle1",
    className: classes.title
  }, override.title), title), description && /*#__PURE__*/React.createElement(Text, _extends({
    type: "caption",
    color: theme.colors.textLight.secondary,
    className: classes.description
  }, override.description), description), buttonList), [buttonList, classes.description, classes.emptyView, classes.illustration, classes.title, description, illustration, override.description, override.emptyView, override.illustration, override.title, title, theme]);
  const renderImageLast = useMemo(() => /*#__PURE__*/React.createElement("div", _extends({
    className: classes.emptyViewLast
  }, override.emptyViewLast), /*#__PURE__*/React.createElement(Text, _extends({
    type: "subtitle1",
    className: classes.title
  }, override.title), title), /*#__PURE__*/React.createElement(Text, _extends({
    type: "caption",
    color: theme.colors.textLight.secondary,
    className: classes.description
  }, override.description), description), /*#__PURE__*/React.createElement("div", _extends({
    className: classes.illustration
  }, override.illustration, {
    onClick: onTracking
  }), illustration), buttonList), [buttonList, classes.description, classes.emptyViewLast, classes.illustration, classes.title, description, illustration, onTracking, override.description, override.emptyViewLast, override.illustration, override.title, title, theme]);
  const renderContent = useMemo(() => {
    if (iconType === 'video') return renderImageLast;
    return renderImageFirst;
  }, [iconType, renderImageFirst, renderImageLast]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: rootClassNames
  }, override.root), renderContent, children);
};
EmptyScreen.overrides = ['root', 'emptyView', 'illustration', 'title', 'description'];
process.env.NODE_ENV !== "production" ? EmptyScreen.propTypes = {
  description: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.element),
  illustration: PropTypes.element,
  title: PropTypes.string
} : void 0;
export default /*#__PURE__*/memo(EmptyScreen);